import type { RootState } from '~/redux/store';

export const getBlockTarget = (state: RootState): string => state.app.blockTarget;
